<template>
    <div class="events container-screen">
        <LoadingScreen v-if="loadingPage" />
        <template v-else>
            <div class="events__body">
                <TitleCommon
                    :value="`${getTranslatedText(
                        this.dataGamesPari.game?.name
                    )}`"
                />
                <SelectFilter
                    :dataOption="dataSource"
                    nameFunction="on-filter-events"
                />
                <div class="loto__list__head__button events__butoon-select">
                    <button @click="onSelectAll">
                        {{ getTranslatedText("Select All") }}
                    </button>
                </div>
                <div class="events__content">
                    <div class="events__list">
                        <h3
                            v-show="dataSoureDrawWeek.length > 0"
                            class="event__list-title"
                        >
                            {{ getTranslatedText("draw this week") }}
                        </h3>
                        <div
                            class="events__item same-week mb"
                            :class="{
                                active: eventSelect.includes(v.event_id),
                            }"
                            v-for="v in dataSoureDrawWeek"
                            :key="v.draw_date"
                            @click="onSelectEvent(v.event_id, v)"
                        >
                            <span class="events__item-date"
                                >{{ getTranslatedText("Samedi") }}
                                {{ renderDate(v.draw_date) }}</span
                            >
                        </div>
                        <h3
                            v-show="dataSourceFilter.length > 0"
                            class="event__list-title"
                        >
                            {{ getTranslatedText("prochain tirages") }}
                        </h3>
                        <div
                            class="events__item"
                            :class="{
                                active: eventSelect.includes(v.event_id),
                            }"
                            v-for="(v, i) in dataSourceFilter"
                            :key="i"
                            @click="onSelectEvent(v.event_id, v)"
                        >
                            <span class="events__item-date"
                                >{{ getTranslatedText("Samedi") }}
                                {{ renderDate(v.draw_date) }}</span
                            >
                        </div>
                    </div>
                    <div class="events_box-button">
                        <button
                            @click="$router.push('/')"
                            class="button button__active no-hover"
                        >
                            {{ getTranslatedText("back") }}
                        </button>
                        <ButtonCommon
                            type="error"
                            :isNoHover="true"
                            :class-name="'button__continue'"
                            value="continue"
                            :isLoading="isLoadingButton"
                            nameFunction="on-events-continue"
                        />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {
    formatDateUTC20,
    isArrayEmpty,
    isCurrentWeek,
    isSameDay,
} from "@/utils/utils";

import GamesService from "@/services/games.service";
import pathAssetsMixins from "@/mixins/pathAssets/path-assets-mixins";
import languageMixins from "@/mixins/language/language-mixins";
import EventBus from "@/utils/EventBus";
import ButtonCommon from "@/components/common/button/index.vue";
import LoadingScreen from "@/components/common/loading/index.vue";
import TitleCommon from "@/components/common/title/index.vue";
import SelectFilter from "@/components/games/events/select/index.vue";

export default {
    mixins: [pathAssetsMixins, languageMixins],
    components: { ButtonCommon, SelectFilter, LoadingScreen, TitleCommon },
    data() {
        return {
            dataSource: [],
            dataSoureDrawWeek: [],
            dataSourceFilter: [],
            dataSourceGames: null,
            eventSelect: [],
            eventInfo: [],
            loadingPage: true,
            isLoadingButton: false,
            dataGamesPari: [],
        };
    },
    mounted() {
        this.fetchData();
        this.getDraws();
    },
    created() {
        EventBus.$on("on-filter-events", (param) => this.onFilterEvents(param));
        EventBus.$on("on-events-continue", () => this.onEventContinue());
    },
    destroyed() {
        EventBus.$off("on-filter-events");
        EventBus.$off("on-events-continue");
    },
    methods: {
        async fetchData() {
            this.loadingPage = true;
            GamesService.getListGames("pari-mutuel-lotto")
                .then((res) => {
                    if (res.data[0].game.config.setup[1]) {
                        this.dataGamesPari = res.data[0];
                        this.$store.dataGamesPari = res.data[0];
                        this.loadingPage = false;
                    }
                })
                .catch((error) => {
                    this.loadingPage = false;
                    console.log(error);
                });
        },
        getDraws() {
            GamesService.getListEvents("pari-mutuel-lotto")
                .then((res) => {
                    this.loadingPage = false;
                    this.dataSoureDrawWeek = res.data.filter((x) =>
                        this.isCheckDrawThisWeek(x.draw_date)
                    );

                    let lengthData = this.dataSoureDrawWeek.length > 0 ? 7 : 8;

                    this.dataSourceFilter = res.data
                        .filter((x) => !this.isCheckDrawThisWeek(x.draw_date))
                        .slice(0, lengthData);
                    this.dataSource = res.data.splice(0, lengthData + 1);
                    this.loadingPage = false;
                    if (!isArrayEmpty(res.data))
                        localStorage.setItem("draw-645", res.data[0].draw_date);
                })
                .catch((err) => {
                    this.loadingPage = false;
                    console.log(err);
                });
        },
        onSelectAll() {
            if (this.dataSource.length === this.eventSelect.length) {
                this.eventSelect = [];
                this.eventInfo = [];
            } else {
                this.dataSource.forEach((item) => {
                    const index = this.eventSelect.findIndex(
                        (x) => x === item.event_id
                    );
                    if (index === -1) {
                        this.eventSelect.push(item.event_id);
                        this.eventInfo.push({
                            name: item.draw_name,
                            date: item.draw_date,
                        });
                    }
                });
            }
        },

        onSelectEvent(eventId, item) {
            const index = this.eventSelect.findIndex((x) => x === eventId);
            if (index !== -1) {
                this.eventSelect.splice(index, 1);
                this.eventInfo.splice(index, 1);
            } else {
                this.eventSelect.push(eventId);
                this.eventInfo.push({
                    name: item.draw_name,
                    date: item.draw_date,
                });
            }
        },

        isCheckDrawThisWeek(date) {
            return isCurrentWeek(date);
        },

        renderDate(date) {
            const dateFormat = formatDateUTC20(date);

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}H${dateFormat.minutes}`;

            return valueDate;
        },
        onFilterEvents(value) {
            let dataSourceFilter = [...this.dataSource];
            if (value !== "all") {
                dataSourceFilter = this.dataSource.filter(
                    (x) => x.event_id === value
                );
            }
            this.dataSourceFilter = dataSourceFilter;
        },
        onEventContinue() {
            if (isArrayEmpty(this.eventSelect)) {
                const param = {
                    text: "Please choose the game",
                    type: "warning",
                };
                EventBus.$emit("show-notications", param);

                return false;
            } else {
                const maxPicks =
                    this.$store.dataGamesPari.length > 0
                        ? this.$store.dataGamesPari.game?.config?.setup[1]
                              .maxPicks
                        : this.dataGamesPari.game?.config?.setup[1].maxPicks;
                const minPicks =
                    this.$store.dataGamesPari.length > 0
                        ? this.$store.dataGamesPari.game?.config?.setup[1].picks
                        : this.dataGamesPari.game?.config?.setup[1].picks;
                let param = {
                    title: this.dataGamesPari.game?.name,
                    game: this.dataGamesPari.game?.slug,
                    gameNumber: this.dataGamesPari.game?.game_id,
                    maxPicks: maxPicks,
                    minPicks: minPicks,
                    numberQp: minPicks,
                    event_id: this.eventSelect,
                    eventInfo: this.eventInfo,
                    selection: [],
                    draws: 1,
                    wager: this.dataGamesPari.game?.price,
                    isPariMutuelLotto: true,
                };
                localStorage.setItem("loto645-event", JSON.stringify(param));
                this.$router.push("/loto-645/numbers");
            }
        },
    },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/games/_event.scss";
</style>
